import { FormlyModule } from '@ngx-formly/core';
import { FormlySelectModule } from '@ngx-formly/core/select';

import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatInputModule } from '@angular/material/input';

import { SnButtonModule } from '@lib/ui/button';
import { SnIconModule } from '@lib/ui/icon';

import { SnAutocompleteFormField } from './components/form-field/autocomplete.form-field';

@NgModule({
  imports: [
    // Angular
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    // Material
    MatInputModule,
    MatAutocompleteModule,
    // Formly
    FormlySelectModule,
    FormlyModule.forChild({
      types: [
        {
          name: 'autocomplete',
          component: SnAutocompleteFormField,
          wrappers: ['form-field'],
        },
      ],
    }),
    // Libs
    SnIconModule,
    SnButtonModule,
  ],
  declarations: [SnAutocompleteFormField],
})
export class SnFormAutocompleteModule {}
